export const RESPONSE_TYPE_HEADER_NAME = "X-Obg-Response-Type";
export const enum ResponseTypeHeaderValue {
	Ssr = "ssr",
	SeoSsr = "seoSsr",
}
